module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_7016.6751d483.png";